import { Component } from '@angular/core';

@Component({
  selector: 'i-checkbox',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none">
      <path
        d="M40.8824 0.00407647C44.6623 -0.127918 47.8427 2.83789 47.9747 6.61773L49.1713 40.8826C49.3033 44.6624 46.3375 47.8428 42.5576 47.9748L8.29279 49.1714C4.51295 49.3034 1.33251 46.3376 1.20051 42.5577L0.00395927 8.29291C-0.128036 4.51307 2.83778 1.33263 6.61761 1.20063L40.8824 0.00407647ZM36.8103 12.3358C35.6354 11.5407 34.0382 11.8537 33.2431 13.0286L21.072 31.0572L15.2984 25.6733C14.2567 24.7019 12.6292 24.7588 11.6685 25.8001C10.7078 26.8414 10.7539 28.4693 11.7952 29.43L19.7741 36.8704C20.3281 37.387 21.0763 37.6289 21.8133 37.5496C22.5503 37.4703 23.2328 37.0605 23.6505 36.4348L37.5031 15.9031C38.2983 14.7282 37.9852 13.131 36.8103 12.3358Z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconCheckbox {}
